const ADMIN_EVENT_KEY = "ea_event";

export function getStoredEventId(defaultId) {
  try {
    return sessionStorage.getItem(ADMIN_EVENT_KEY) || defaultId;
  } catch {
    return defaultId;
  }
}

export function setStoredEventId(eventId) {
  sessionStorage.setItem(ADMIN_EVENT_KEY, eventId);
}
